<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>电子合同签署</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 检索 -->
            <el-form :model="listQuery" :inline="true">
                <el-form-item label="合同类型">
                    <el-select v-model="listQuery.type" filterable collapse-tags clearable>
                        <el-option v-for="(value, key) in contractTypes" :key="key" :label="value" :value="key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="姓名">
                    <el-input v-model="listQuery.name" placeholder filterable clearable></el-input>
                </el-form-item>
                <el-form-item label="电话">
                    <el-input v-model="listQuery.tel" placeholder filterable clearable></el-input>
                </el-form-item>
                <el-form-item label="签署状态">
                    <el-select v-model="listQuery.state" placeholder filterable clearable>
                        <el-option value="1" label="未签署"></el-option>
                        <el-option value="2" label="已签署"></el-option>
                        <el-option value="3" label="已取消"></el-option>
                    </el-select>
                </el-form-item>

                <el-button type="primary" @click="clickSearch">查询</el-button>
            </el-form>
            <el-row class="btn-margin">

                <el-button class v-per="'fuwuhezuoxieyi'" type="success" plan @click="goSignBaodi()">保洁服务合作协议
                </el-button>
<el-button class  type="success" plan @click="goSignGeren()">授权个人信息签署
                </el-button>
                <el-button class type="success" plan @click="goSignLease()">设备租赁合同</el-button>
                <el-button class v-per="'baomixieyi'" type="warning" plan @click="goBaomi()">保密协议</el-button>
                <el-button class v-per="'bjzhongzhixieyi'" type="danger" plan @click="goResign()">合同关系终止协议</el-button>
                <el-button class type="success" plan @click="goSignXiaoXiang()">肖像权使用授权书</el-button>
                <!-- <el-button class type="primary" v-per="'fcContractExport'" plan @click="exportExcel">导出合同数据</el-button> -->
            </el-row>
            <!-- 列表数据 -->
            <el-table :data="processListData" border style="width: 100%" class="table">
                <el-table-column prop="processId" label="流程ID"></el-table-column>
                <el-table-column prop="contractNo" label="合同编号"></el-table-column>
                <el-table-column prop="fraName" label="加盟商"></el-table-column>
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column prop="tel" label="电话"></el-table-column>
                <el-table-column prop="address" label="地址"></el-table-column>

                <el-table-column prop="type" label="合同类型">
                    <template slot-scope="scope">
                        <el-tag>{{ contractTypes[scope.row.type] }}</el-tag>

                    </template>
                </el-table-column>
                <el-table-column prop="state" label="签署状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.state == 1">未签署</el-tag>
                        <el-tag v-if="scope.row.state == 2" type="success">已签署</el-tag>
                        <el-tag v-if="scope.row.state == 3">已取消</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="发起时间" :formatter="dateFormatA"></el-table-column>

                <el-table-column prop="creatorName" label="操作" fixed="right" width="250px">
                    <template slot-scope="scope">

                        <el-button type="text" @click="checkSignAdressBtn(scope.row)">查看签约地址</el-button>
                        <el-button type="text" @click="previewBtn(scope.$index, scope.row)"
                            v-loading.fullscreen.lock="fullscreenLoading">预览
                        </el-button>
                        <el-button type="text" @click="cancelSign( scope.row)"
                           class="textWarning" v-if="scope.row.state == 1&&(scope.row.type== 105||scope.row.type== 110)">取消
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页  -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>

        <!-- 签约地址 -->
        <signAdressDia ref="signAdressDiaRef" />

        <!--疫情去保底-->
        <signBaodi @querySearch="querySearch" ref="signBaodi" />

        <!-- 保密协议 -->
        <baomi @querySearch="querySearch" ref="baomi" />
        <!-- 合同解除 -->
        <resign @querySearch="querySearch" ref="resign" />
         <!--设备租赁合同-->
    	<signLease @querySearch="querySearch" ref="signLease"/>

    	<signXiaoXiang @querySearch="querySearch" ref="signXiaoXiang"/>

      <el-dialog title="授权个人信息签署" :visible.sync="grxisq" :close-on-click-modal="false" width="600px" center class="person-dialog">
            <el-form :inline="true" ref="personInfoForm" :model="personInfoForm" :rules="Rules">
                <el-row>

                    <el-col :span="20">
                        <el-form-item label="服务者" prop="personId">
                            <el-select v-model="personInfoForm.personId"  filterable clearable >
                                <el-option v-for="(item, key) in singList" :key="key" :label="item.workerName+item.workerTel" :value="item.workerNo"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

             <span slot="footer" class="dialog-footer">
                <el-button @click="grxisq = false">取 消</el-button>
                <el-button type="primary" @click="sendAuth">发起授权</el-button>
            </span>
      </el-dialog>

    </div>
</template>
<script>
import Pagination from "@/components/common/Pagination";
import globalData from "@/components/common/globaldata/global.data.vue";
// import contractprocedure from '@/script/api/contractprocedure';
import contractApi from "@/script/api/contractapi";

import signBaodi from "@/components/workercrm/contract/compent/signBaodi";
import baomi from "@/components/workercrm/contract/compent/baomi";
import resign from "@/components/workercrm/contract/compent/resign";
import signAdressDia from '@/components/workercrm/contract/compent/signAdressDia';
import signLease from '@/components/workercrm/contract/compent/signLease';
import signXiaoXiang from '@/components/workercrm/contract/compent/signXiaoXiang';

export default {
    components: { Pagination, signBaodi, baomi, resign, signAdressDia ,signLease,signXiaoXiang},
    data() {
        return {
            contractTypes: {
                108: "保密协议",
                109: "合同终止协议",
                107: '设备租赁合同',
                // 106: '团长-合作协议',
                105: "保洁服务合作协议",
                1052: "保洁服务合作协议-美团",
                1053: "保洁服务合作协议-员工制",
                110: "个人信息授权",
                111: "肖像权使用授权书",
                112: "新农保告知书"
            },
            showSign: false,
            PDFVisible: false,
            contractUrl: "",

            fullscreenLoading: false,
            processListData: [],
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {
                name: "",
                tel: "",
                state: null,
                type: null,
            },
            grxisq:false,
            singList:[],
            personInfoForm:{
                personId:'',
            },
            Rules: {
             personId: [{ required: true, message: "请选择服务者", trigger: "change" }],
            },


        };
    },
    created() {
        this.querySearch();
    },
    methods: {
        goSignXiaoXiang(){
          this.$refs.signXiaoXiang.showDetail();
        },
        goSignLease() {
            this.$refs.signLease.showDetail();
        },
        goBaomi() {
            this.$refs.baomi.showDetail();
        },
        goResign() {
            this.$refs.resign.showDetail();
        },
        goSignBaodi() {
            this.$refs.signBaodi.showDetail(null);
        },
        goSignGeren(){
            if(this.singList.length==0){
        this.loadSingList();
            }

          this.grxisq=true;
          this.personInfoForm.personId='';
        },
         loadSingList() {

            contractApi.$ajaxGetAllWorkerList().then((res) => {
                if (res.data.errno == 0) {
                    this.singList = res.data.data;

                }
            });
        },
        checkSignAdressBtn(row) {
            this.$refs.signAdressDiaRef.signAdressDiaRow(row);
        },
        sendAuth(){
            this.$refs['personInfoForm'].validate(valid => {
        if (valid) {
             contractApi.$ajaxSingGerenxinxisouquan({
                            workerNo: this.personInfoForm.personId,
                        })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("操作成功");
                                this.grxisq=false;
                                this.querySearch();
                            }
                        });

        }
            });

        },
        clickSearch() {
            this.currentPage = 1;
            this.querySearch();
        },
        // exportExcel() {
        //     let reqData = {
        //         name: this.listQuery.name,
        //         tel: this.listQuery.tel,
        //         state: this.listQuery.state,
        //         type: this.listQuery.type,
        //         isExport: true,
        //         userId: globalData.userInfo.id,
        //     };
        //     contract.$download(reqData, "合同数据明细");
        // },
        //查询
        querySearch() {
            let reqData = {
                name: this.listQuery.name,
                tel: this.listQuery.tel,
                state: this.listQuery.state,
                type: this.listQuery.type,
                pageNo: this.currentPage,
                pageSize: this.pageSize,
            };
            contractApi.$ajaxWorkerContractGetPageList(reqData).then((res) => {
                if (res.data.errno == 0) {
                    this.total = res.data.data.total;
                    this.processListData = res.data.data.list;
                }
            });
        },
        //预览
        previewBtn(index, row) {
            this.fullscreenLoading = true;
            contractApi
                .$ajaxselectContractFile({
                    procedureId: row.processId,
                })
                .then((res) => {
                    if (res.data.errno == 0) {
                        window.open(
                            "/static/pdf/web/viewer.html?file=" +
                            encodeURIComponent(res.data.data.downloadUrl)
                        );
                        this.fullscreenLoading = false;
                    }
                });
        },
    //   取消
    cancelSign(row){
           this.$confirm("是否确定取消?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    contractApi.$ajaxCancelSign({
                            processId: row.processId,
                        })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("取消成功");
                                this.querySearch();
                            }
                        });
                })
                .catch(() => { });

    },




    },
};
</script>
<style scoped>
.person-dialog .el-select{
    width:300px;

}
.person-dialog .el-dialog__body{
   height:160px;

}
 </style>
